export default __webpack_public_path__ + "static/media/ref-icon.eed14316.png";